const fontWeights = {
  regular: "400",
  medium: "500",
  semiBold: "600",
};

export default fontWeights;
